function PrescriptionVO(id, certificatePassword, prescribedDrugs, issueDate, dateFrom, visitCard, type, additionalRight, dosageSummary,
                        attachment, nfzOffice, alreadyPrinted, p1Prescription) {
    this.id = id;

    this.certificatePassword = certificatePassword;
    this.prescribedDrugs = prescribedDrugs;
    this.issueDate = issueDate;
    this.dateFrom = dateFrom;
    this.visitCard = visitCard;
    this.type = type;
    this.additionalRight = additionalRight;
    this.dosageSummary = dosageSummary;
    this.attachment = attachment;
    this.nfzOffice = nfzOffice;
    this.alreadyPrinted = alreadyPrinted;
    this.p1Prescription = p1Prescription;

    var _typeContext = {
        prescribedDrugs: PrescribedDrugVO,
        issueDate: Date,
        dateFrom: Date,
        visitCard: VisitCardVO,
        additionalRight: DictionaryElementVO,
        nfzOffice: NfzOfficeVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
